import React, { ChangeEvent, Component, TextareaHTMLAttributes } from 'react'

import classNames from 'classnames/bind'

import styles from './Textarea.module.scss'

interface IProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  required: boolean
  value: string
  resize?: boolean
  counter?: boolean
  cb?: (value: string) => void
  isDark?: boolean
  label?: string
  error?: boolean
  desc?: string
}

interface IState {
  value: string
}

const cx = classNames.bind(styles)

export class Textarea extends Component<IProps, IState> {
  constructor(public props: IProps) {
    super(props)

    this.state = {
      value: props.value,
    }
  }

  componentDidUpdate(prev: IProps): void {
    if (prev.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  handleChange = (ev: ChangeEvent<HTMLTextAreaElement>): void => {
    this.setState(
      {
        value: ev.target.value,
      },
      () => {
        this.props.cb && this.props.cb(ev.target.value)
      }
    )
  }

  renderCounter = (max: number | undefined): JSX.Element => {
    const to = max ? `/${max}` : ''

    return (
      <span
        className={styles.counter}
      >{`${this.state.value?.length}${to}`}</span>
    )
  }

  renderWrapper = (): JSX.Element => {
    const { required, resize, label, isDark, error, disabled } = this.props
    const wrapperClasses = cx('wrapper', {
      required: required,
      resize: resize,
      label: label,
      dark: isDark,
      disabled: disabled,
      error,
    })

    return this.props?.label ? (
      <label className={wrapperClasses}>
        <small>{label}</small>
        {this.renderTextarea()}
      </label>
    ) : (
      <div className={wrapperClasses}>{this.renderTextarea()}</div>
    )
  }

  renderTextarea = (): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { counter, isDark, cb, desc, error, ...rest } = this.props

    return (
      <>
        <textarea
          {...rest}
          value={this.state.value}
          onChange={(ev: ChangeEvent<HTMLTextAreaElement>) =>
            this.handleChange(ev)
          }
        />
        <div className={styles.footer}>
          {desc && <span className={styles.desc}>{desc}</span>}
          {counter &&
            this.renderCounter(rest.maxLength ? rest.maxLength : undefined)}
        </div>
      </>
    )
  }

  render(): JSX.Element {
    return this.renderWrapper()
  }
}
